export enum BoxStateEnum {
    OK = 'OK',
    KO = 'KO',
}
